import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DoxExplorerTitleSortBar from './doxExplorerTitleSortBar'
import DoxExplorerFilesTable from './doxExplorerFilesTable'
import { toast, Slide } from 'react-toastify'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'
import DoxExplorerTitleBar from './doxExplorerTitleBar'
import Button from '../../../../../../components/library/buttons/Button'
import DoxExplorerConfirmDelete from './doxExplorerConfirmDelete'
import DoxExplorerConfirmRename from './doxExplorerConfirmRename'
import { useSelector } from 'react-redux'
import BulkDownloadIcon from '../graphics/blkDownloadIcon'
import BulkDownloadErrorIcon from '../graphics/blkDownloadErrorIcon'
import { useFileDownload } from '../hooks/useFileDownloadHook';
import { Fragment } from 'react'
import { trackEvent, HeapEvents } from '../../../../../../services/util/AnalyticsUtil'
import LoadingSpinner from  "../../../../../../components/library/loaders/LoadingSpinnerSmall"

const DoxExplorerMainFiles = (props) => {
    const translateString = useTranslationContext();
    const associateId = useSelector(state => state.tickets.selectedTicket.associateId);
    const loggedInUserId = useSelector(state => state.accountData.employeeId);
    const bulkDownloadEligibility = associateId === loggedInUserId;
    const { taxYear, ticketId, layoutType, targetName } = props;
    const { onSetTaxYear } = props;
    const [sortOverride, setSortOverride] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [deleteFileData, setDeleteFileData] = useState(null)
    const [deleteErrorStatus, setDeleteErrorStatus] = useState(null)
    const [renameFileData, setRenameFileData] = useState(null)
    const [renameErrorStatus, setRenameErrorStatus] = useState(null)
    const [renameFileName, setRenameFileName] = useState(null)
    const [renameCanSave, setRenameCanSave] = useState(false)
    const [working, setWorking] = useState(false)
    const [recoverErrorStatus, setRecoverErrorStatus] = useState(null)
    const [recoverFileData, setRecoverFileData] = useState(false)
    const [fileIds, setFiledIds] = useState(new Set());
    const [fileList, setFileList] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [showError, setShowError] = useState(false)
    const [, , , bulkDownload] = useFileDownload()
    const [isLoading, setIsLoading] = useState(false)

    const handleSelectSort = (sortColumn) => {
        setSortOverride(sortColumn)
    }

    const handleSearch = (searchTerm) => {
        setSearchValue(searchTerm)
    }

    const options = {
        className: 'black-background-toast',
        position: "bottom-left",
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    }

    const handleViewFileNotification = (textKey) => {
        toast.info(translateString(textKey), options);
    }

    const showAllTaxYears = () => {
        onSetTaxYear(null)
    }

    const handleStartDeleteFile = async (deleteFileData) => {
        setWorking(false)
        setDeleteErrorStatus(null)
        setDeleteFileData(deleteFileData)
    }

    const handleStartRenameFile = async (renameFileData) => {
        setWorking(false)
        setRenameErrorStatus(null)
        setRenameFileData(renameFileData)
    }

    const handleFileRecover = async (fileId) => {
        setRecoverFileData(false)
    }

    const handleCancelFileOperation = () => {
        if (deleteFileData && deleteFileData.onCancel) {
            deleteFileData.onCancel()
            setDeleteFileData(null)
            setDeleteErrorStatus(null)
        }
        if (renameFileData && renameFileData.onCancel) {
            renameFileData.onCancel()
            setRenameFileData(null)
            setRenameErrorStatus(null)
        }
    }

    const handleDeleteFile = async (ev) => {
        setDeleteErrorStatus(null)
        setWorking(true)
        if (deleteFileData && deleteFileData.onDeleteFile) {
            var status = await deleteFileData.onDeleteFile(deleteFileData.documentId)
            if (status === 'fail') {
                setDeleteErrorStatus(status)
            } else {
                setDeleteFileData(null)
            }
            setWorking(false)
        }
    }

    const handleRenameFile = async () => {
        setRenameErrorStatus(null)
        var duplicate = (renameFileData.fileList || []).find(x => (x.fileName).toLowerCase() === (renameFileName || '').toLowerCase() && x.documentStatus != 'Deleted')
        if (duplicate) {
            setRenameErrorStatus('duplicate')
            return;
        }

        setWorking(true)
        if (renameFileData && renameFileData.onRenameFile) {
            var status = await renameFileData.onRenameFile(renameFileData.documentId, renameFileName)
            if (status === 'fail') {
                setRenameErrorStatus(status)
            } else {
                setRenameFileData(null)
            }
            setWorking(false)
        }
    }

    const handleNewFileName = (fn) => {
        if (renameFileName !== fn) {
            setRenameFileName(fn);
        }
    }

    const handleRenameCanSave = (canSave) => {
        if (canSave !== renameCanSave) {
            setRenameCanSave(canSave)
        }
    }

    const fileOperationListener = (updatedFileList, loadedFlag) => {
        setFileList(updatedFileList)
        setLoaded(loadedFlag)
    }

    const onFileIdSelected = (fileId) => {
        setFiledIds(prevFileIds => {
            const newFileIds = new Set(prevFileIds);
            newFileIds.add(fileId);
            setShowError(false);
            return newFileIds
        })
    }

    const onFileIdRemoved = (fileId) => {
        setFiledIds(prevFileIds => {
            const newFileIds = new Set(prevFileIds);
            newFileIds.delete(fileId);
            return newFileIds
        })
    }

    const handleBulkDownload = async () => {
        if (fileIds.size === 0) {
            setShowError(true);
        } else {
            setShowError(false);
            setIsLoading(true);
            try {
                await bulkDownload(ticketId, `${targetName} ${taxYear}`, Array.from(fileIds));
                trackEvent(HeapEvents.DOX_BTN_DOWNLOADALL);
                setIsLoading(false);
            } catch (error) {
                console.error("Error in bulk download:", error);
                setIsLoading(false);
            }
        }
    };

    return taxYear ? (
        <div className={classnames('doxe-container', layoutType)}>
            {!deleteFileData &&
                <DoxExplorerTitleSortBar tax_year={taxYear}
                    onBackToRoot={onSetTaxYear} layoutType={layoutType} selectedSort={sortOverride}
                    onSelectSort={handleSelectSort} onSearch={handleSearch} />
            }
            {deleteFileData &&
                <DoxExplorerTitleBar textKey='Dox.DocumentExplorer.Delete' />
            }
            {Number(ticketId) > 0 && !deleteFileData && !renameFileData &&
                <DoxExplorerFilesTable layoutType={layoutType} onShowNotification={handleViewFileNotification}
                    ticketId={Number(ticketId)} sortOverride={sortOverride} targetName={targetName} hide={!!deleteFileData}
                    searchValue={searchValue} onSelectSort={handleSelectSort} onStartDelete={handleStartDeleteFile}
                    onStartRename={handleStartRenameFile} onFileRecover={handleFileRecover} bulkDownloadEligibility={bulkDownloadEligibility}
                    onFileIdSelected={onFileIdSelected} onFileIdRemoved={onFileIdRemoved} fileIds={fileIds} fileOperationListener={fileOperationListener}/>
            }
            {!!deleteFileData &&
                <DoxExplorerConfirmDelete fileName={deleteFileData.fileName} errorStatus={deleteErrorStatus} />
            }
            {!!renameFileData &&
                <DoxExplorerConfirmRename documentId={renameFileData.documentId} fileList={renameFileData.fileList}
                    errorStatus={renameErrorStatus} onNewFileName={handleNewFileName} onCanSave={handleRenameCanSave} />
            }
            <div className='doxe-footer'>
                {!deleteFileData && !renameFileData &&
                    <div className='dox-link' onClick={showAllTaxYears}>
                        {translateString('Dox.DocumentExplorer.ViewAll')}
                    </div>
                }
                {!deleteFileData && !renameFileData && loaded && bulkDownloadEligibility &&
                    <Fragment>
                        <div onClick={!isLoading ? handleBulkDownload : null} className={`dox-link blkDownloadButton ${isLoading ? 'dox-bulk-download-inProgress' : ''}`} >
                            <BulkDownloadIcon />
                            <span>{translateString('Dox.DocumentExplorer.Download')}
                                {fileIds.size}/{fileList?.filter(x => x.documentStatus !== 'Deleted').length}</span>
                            {isLoading &&
                                <div className='dox-bulk-download-loading'>
                                    <LoadingSpinner />
                                </div>
                            }
                        </div>
                        {showError &&
                            <div className='dox-bulk-download-error'>
                                <BulkDownloadErrorIcon />
                                <span>{translateString('Dox.DocumentExplorer.Errors.NoFilesSelectedError')}</span>
                            </div>
                        }
                    </Fragment>
                }
                {deleteFileData &&
                    <div className='doxe-footer-btns'>
                        <Button
                            elementId='doxe-footer-cancel-btn'
                            labelKey='App.Cancel'
                            buttonStyles='secondary'
                            onClick={handleCancelFileOperation}
                        />
                        <Button
                            elementId='doxe-footer-confirm-btn'
                            labelKey='Dox.DocumentExplorer.ConfirmDelete'
                            buttonStyles='primary'
                            onClick={handleDeleteFile}
                            loading={working}
                        />
                    </div>
                }
                {renameFileData &&
                    <div className='doxe-footer-btns'>
                        <Button
                            elementId='doxe-footer-cancel-btn'
                            labelKey='App.Cancel'
                            buttonStyles='secondary'
                            onClick={handleCancelFileOperation}
                        />
                        <Button
                            elementId='doxe-footer-confirm-btn'
                            labelKey='Dox.DocumentExplorer.Save'
                            buttonStyles='primary'
                            onClick={handleRenameFile}
                            loading={working}
                            disabled={!renameCanSave}
                        />
                    </div>
                }
            </div>
        </div>
    ) : null
}

DoxExplorerMainFiles.propTypes = {
    taxYear: PropTypes.number.isRequired,
    ticketId: PropTypes.number.isRequired,
    layoutType: PropTypes.string.isRequired,
    targetName: PropTypes.string,
    onSetTaxYear: PropTypes.func.isRequired
}

export default DoxExplorerMainFiles;